import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IMenu, ISelect } from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../operations/models/operations.models';
import { ITermsAndConditionsForm } from '../models/workflows.models';
import { MenuItemAction } from '../../shared/models/master.models';

/**
 * Host policy checks HOME (NIF-845).
 */
export interface WorkflowFormHomeChecksHost {
	form: FormGroup;
	policyChecksOptions: ISelect[];
	selectedPolicyCheckControl: FormControl;
	showModalTermsConditions: { mode: MenuItemAction; form?: ITermsAndConditionsForm; index?: number } | null;
	readonly checksArray: FormArray;
	updatePolicyChecksOptions(): void;
}

/**
 * Policy checks / términos HOME del editor (NIF-845).
 */
@Injectable({
	providedIn: 'root',
})
export class WorkflowFormHomeChecksService {
	public removeCheck(host: WorkflowFormHomeChecksHost, index: number): void {
		const removedCheck = host.checksArray.at(index).value;
		(host.form.get(`operations.${OPERATION_TYPE.HOME}.policy_checks`) as FormArray).removeAt(index);

		if (host.checksArray.length === 0) {
			host.form.get(`operations.${OPERATION_TYPE.HOME}.tecalis_policy_check`)?.setValue(true);
		}

		if (removedCheck.uuid) {
			const existsInOptions = host.policyChecksOptions.some((pc: ISelect) => pc.id === removedCheck.uuid);
			if (!existsInOptions) {
				host.policyChecksOptions = [
					...host.policyChecksOptions,
					{
						id: removedCheck.uuid,
						label: removedCheck.custom_id,
						value: removedCheck,
					},
				].sort((a, b) => a.label.localeCompare(b.label));
			}
		}

		host.selectedPolicyCheckControl.setValue(null);
	}

	public formCheck(
		host: WorkflowFormHomeChecksHost,
		response: { mode: MenuItemAction; form?: ITermsAndConditionsForm; index?: number },
	): void {
		if (response) {
			if (response.mode === MenuItemAction.CREATE) {
				const checks = new FormGroup({
					custom_id: new FormControl(response.form.custom_id),
					html: new FormControl(response.form.html),
					required: new FormControl(response.form.required),
					uuid: new FormControl(response.form.uuid || null),
				});
				(host.form.get(`operations.${OPERATION_TYPE.HOME}.policy_checks`) as FormArray).push(checks);
				if (response.form.uuid) {
					host.policyChecksOptions = host.policyChecksOptions.filter(
						(pc: ISelect) => pc.id !== response.form.uuid,
					);
				}
			}
			if (response.mode === MenuItemAction.EDIT) {
				(host.form.get(`operations.${OPERATION_TYPE.HOME}.policy_checks`) as FormArray)
					.at(response.index)
					.setValue(response.form);
			}
		}
		host.showModalTermsConditions = null;
	}

	public createPolicyCheck(host: WorkflowFormHomeChecksHost, reload: boolean): void {
		if (reload) {
			host.updatePolicyChecksOptions();
		}
		host.showModalTermsConditions = null;
	}

	public policyCheckMenuChange(host: WorkflowFormHomeChecksHost, action: IMenu, index: number): void {
		const actions = {
			[MenuItemAction.DELETE]: () => this.removeCheck(host, index),
		};
		actions[action.id]?.() ?? null;
	}

	public tecalisPolicyMenuChange(host: WorkflowFormHomeChecksHost, action: IMenu): void {
		if (action.id === MenuItemAction.DELETE) {
			host.form.get(`operations.${OPERATION_TYPE.HOME}.tecalis_policy_check`)?.setValue(false);
		}
	}
}
